import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { reduxForm, Field } from 'redux-form';
import {
  Grid,
  GridRow,
  GridColumn,
  Form,
  Icon,
  Popup,
} from 'semantic-ui-react';

import { SelectField } from 'Common/SemanticWrapper';
import { FAMILY_MATCH_UTILITY_FORM_NAME } from 'Common/FormEnum';
import { FamilyMatchUtilityFormEnum as Fields } from 'Common/FieldEnum';

import { options } from '../helpers/constants';

class FamilyMatchUtilityFormContainer extends Component {
  handleDropdownOnChange = data => {
    this.props.setSelectedConfidence(data);

    this.props.getApplicationsAndStudents(data);

    this.props.setSelectedIds({ SystemId: null, HHId: null });

    this.props.clearSelectedStudents();
  };

  render() {
    return (
      <Form name="Family Match Form">
        <Grid>
          <GridRow>
            <GridColumn width="9">
              <Field
                label={
                  <label>
                    <React.Fragment>
                      Confidence Level
                      <Popup
                        basic
                        trigger={
                          <Icon size="large" name="question circle outline" />
                        }
                        content={
                          <div>
                            Users can select a Confidence Level (i.e. how much
                            criteria) that students can be matched for Household
                            Applications.
                          </div>
                        }
                      />
                    </React.Fragment>
                  </label>
                }
                name={Fields.ConfidenceDropdown}
                options={options}
                component={SelectField}
                onChange={(e, data) => this.handleDropdownOnChange(data)}
              />
            </GridColumn>
          </GridRow>
        </Grid>
      </Form>
    );
  }
}

const validate = values => {
  const errors = {};

  if (
    values[Fields.ConfidenceDropdown] > 8 ||
    values[Fields.ConfidenceDropdown] < 0
  ) {
    errors[Fields.ConfidenceDropdown] = 'Unaccepted Confidence Level';
  }

  return errors;
};

export const FamilyMatchUtilityForm = reduxForm({
  form: FAMILY_MATCH_UTILITY_FORM_NAME,
  validate,
  destroyOnMount: false,
})(withRouter(FamilyMatchUtilityFormContainer));



// WEBPACK FOOTER //
// ./src/pages/familymatchutility/components/FamilyMatchUtilityForm.js